import { render, staticRenderFns } from "./OnlineContent.vue?vue&type=template&id=fdd18aa6&scoped=true&"
import script from "./OnlineContent.vue?vue&type=script&lang=js&"
export * from "./OnlineContent.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=fdd18aa6&scoped=true&lang=css&"
import style1 from "@/assets/css/chunkUpload.css?vue&type=style&index=1&id=fdd18aa6&scoped=true&lang=css&"
import style2 from "./OnlineContent.vue?vue&type=style&index=2&id=fdd18aa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd18aa6",
  null
  
)

export default component.exports